import { render, staticRenderFns } from "./FundScreenerV2View.vue?vue&type=template&id=2a7f531f&"
import script from "./FundScreenerV2View.vue?vue&type=script&lang=js&"
export * from "./FundScreenerV2View.vue?vue&type=script&lang=js&"
import style0 from "./FundScreenerV2View.vue?vue&type=style&index=0&id=2a7f531f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports